// The app's name and colour, shown before sign-in too.
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;
let pending = null;

export function applyBrand(hex) {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
  if (m) document.documentElement.style.setProperty("--brand", m.slice(1).map((h) => parseInt(h, 16)).join(" "));
}

function load() {
  if (!pending) {
    pending = api.get("/site").then(({ data }) => {
      cached = data;
      applyBrand(data.brand_color);
      document.title = data.name;
      return data;
    }).catch(() => (pending = null));
  }
  return pending;
}

export function useSite() {
  const [site, setSite] = useState(cached);
  useEffect(() => {
    if (!cached) load().then((d) => d && setSite(d));
  }, []);
  return site || { name: "", company: "" };
}
